<template>
  <header class="header">
    <div class="header-inner">
      <div class="header-logo">
        <img src="../assets/images/testhiveqa-logo.jpeg" alt="TestHiveQA Logo">
      </div>
      <button @click="scrollToTop" class="header-cta">Join Waitlist</button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  methods: {
    scrollToTop() {
      this.$emit('scroll-to-top');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
</script>
